import { Component, OnInit } from "@angular/core";
import { DataService_scanstationtracking } from "./shared/data.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { ConfirmationService } from "primeng/api";
import { Table } from "primeng/table";
import { UserService } from "../../../shared/services/user.service";
import { wsScanStationTrackingUpdateParmInfo } from "./shared/wsScanStationTrackingUpdateParmInfo";
import { wsScanStationTrackingUpdateItemInfo } from "./shared/wsScanStationTrackingUpdateParmInfo";

import { ViewChild } from "@angular/core";

import * as moment from "moment";

@Component({
	selector: "app-scan-station-tracking",
	templateUrl: "./scanstationtracking.component.html",
	styleUrls: ["./scanstationtracking.component.css"],
})
export class ScanStationTrackingComponent implements OnInit {
	@ViewChild("mydt") mydt: Table;
	constructor(
		private dataService: DataService_scanstationtracking,
		private selectService: SchoolselectorService,
		private dialogService: DialogService,
		private userService: UserService,
		private confirmationService: ConfirmationService
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;

	subscription: any;
	SelectedSchool: any;
	SelectedFacility: any;
	lstFacility: any = [];
	LoadingFacility: boolean = false;

	ActiveOption: number = -1;
	lstActive: any = [
		{
			ID: -1,
			Desc: "Any",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Decommissioned",
		},
	];

	lstCategory: CategoryInfo[] = [];
	LoadingCategory: boolean = false;
	SelectedColumns: ColumnInfo[] = [];

	SelectedScanStations: any = [];
	lstScanStation: any = [];
	LoadingScanStation: boolean = false;

	Processing: boolean = false;

	//
	// Table
	//
	pagerows: any = 10;
	pagefirst: any = 0;
	errorMessage: any = "";

	//Filter lists
	lstFacilityName: any = [];
	lstFacilityLocationName: any = [];
	lstSchoolFullName: any = [];
	lstIsDecommissionedDesc: any = [];
	lstCurrentPackageVersion: any = [];
	lstSQLServerName: any = [];
	lstIsSeverRequestRebuildDesc: any = [];
	lstSYS_OS_Name: any = [];
	lstSYS_OS_Architecture: any = [];
	lstSYS_OS_Version: any = [];
	lstSYS_CPU_Name: any = [];
	lstSYS_CPU_Cores_Threads: any = [];
	lstEntryModeEnabledDesc: any = [];
	lstExitModeEnabledDesc: any = [];
	lstMealModeEnabledDesc: any = [];
	lstAccessModeEnabledDesc: any = [];
	lstTimeStampModeEnabledDesc: any = [];
	lstEventModeEnabledDesc: any = [];
	lstPrinterEnabledDesc: any = [];
	lstTurnstileEnabledDesc: any = [];
	lstLEDEnabledDesc: any = [];
	lstEnable4ChannelScanningDesc: any = [];
	lstOmniKeyOnlyDesc: any = [];

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------	
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});

		this.loadCategories();
	}	

	//-----------------------------------------------------------------------------------------------------
	//
	//	loadFacility
	//
	//-----------------------------------------------------------------------------------------------------	
	loadFacility() {
		this.LoadingFacility = true;
		var result = this.dataService.FacilitySelectList(this.SelectedSchool.SchoolID);
		result.subscribe(
			(response) => {
				this.LoadingFacility = false;

				this.lstFacility = response;

				if (this.SelectedSchool.SchoolID <= 0) {
					this.lstFacility.unshift({
						FacilityID: -1,
						FacilityName: "All",
						FacilityFullName: "All",
					});
				}

				this.SelectedFacility = this.lstFacility[0];

				this.loadTableData();
			},
			(error) => {
				this.LoadingFacility = false;
			}
		);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	loadCategories
	//
	//-----------------------------------------------------------------------------------------------------		
	loadCategories() {
		this.LoadingCategory = true;

		var result = this.dataService.ScanStationTrackingColumnOptionSelectList();
		result.subscribe(
			(response: any) => {
				this.LoadingCategory = false;

				// this.lstCategory = response;

				this.UpdateCategories(response);
			},
			(error) => {
				this.LoadingCategory = false;
			}
		);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	UpdateCategories
	//
	//-----------------------------------------------------------------------------------------------------		
	UpdateCategories(lstCategory: any[]) {
		var AllCategories: CategoryInfo[] = [];

		var NextCategory: CategoryInfo = {
			Category: "",
			lstColumns: [],
		};

		for (var z = 0; z < lstCategory.length; z++) {
			var next = lstCategory[z];

			if (NextCategory.Category == "") {
				NextCategory.Category = next.Category;
			}

			if (next.Category != NextCategory.Category) {
				AllCategories = [...AllCategories, NextCategory];
				NextCategory = {
					Category: next.Category,
					lstColumns: [],
				};
			}

			var nextInfo: ColumnInfo = {
				ColumnName: next.ColumnName,
				Selected: next.Selected,
				ReadOnly: next.ReadOnly,
				DataField: next.DataField,
			};

			if (nextInfo.Selected == true) {
				this.SelectedColumns = [...this.SelectedColumns, nextInfo];
			}

			NextCategory.lstColumns = [...NextCategory.lstColumns, nextInfo];
		}

		AllCategories = [...AllCategories, NextCategory];

		this.lstCategory = AllCategories;

		console.log(this.lstCategory);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	loadTableData
	//
	//-----------------------------------------------------------------------------------------------------		
	loadTableData() {
		this.errorMessage = "";

		this.LoadingScanStation = true;

		var result = this.dataService.ScanStationTrackingSelectList(this.SelectedFacility.FacilityID, this.ActiveOption);
		result.subscribe(
			(response) => {
				this.LoadingScanStation = false;

				this.lstScanStation = response;

				for (var z = 0; z < this.lstScanStation.length; z++) {
					var next = this.lstScanStation[z];
					next.NewSQLServerName = String(next.SQLServerName);
				}

				this.lstFacilityName = Array.from(new Set(this.lstScanStation.map((item: any) => item.FacilityName)));
				this.lstFacilityLocationName = Array.from(new Set(this.lstScanStation.map((item: any) => item.FacilityLocationName)));
				this.lstSchoolFullName = Array.from(new Set(this.lstScanStation.map((item: any) => item.SchoolFullName)));
				this.lstIsDecommissionedDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.IsDecommissionedDesc)));
				this.lstCurrentPackageVersion = Array.from(new Set(this.lstScanStation.map((item: any) => item.CurrentPackageVersion)));
				this.lstSQLServerName = Array.from(new Set(this.lstScanStation.map((item: any) => item.SQLServerName)));
				this.lstIsSeverRequestRebuildDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.IsSeverRequestRebuildDesc)));
				this.lstSYS_OS_Name = Array.from(new Set(this.lstScanStation.map((item: any) => item.SYS_OS_Name)));
				this.lstSYS_OS_Architecture = Array.from(new Set(this.lstScanStation.map((item: any) => item.SYS_OS_Architecture)));
				this.lstSYS_OS_Version = Array.from(new Set(this.lstScanStation.map((item: any) => item.SYS_OS_Version)));
				this.lstSYS_CPU_Name = Array.from(new Set(this.lstScanStation.map((item: any) => item.SYS_CPU_Name)));
				this.lstSYS_CPU_Cores_Threads = Array.from(new Set(this.lstScanStation.map((item: any) => item.SYS_CPU_Cores_Threads)));
				this.lstEntryModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.EntryModeEnabledDesc)));
				this.lstExitModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.ExitModeEnabledDesc)));
				this.lstMealModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.MealModeEnabledDesc)));
				this.lstAccessModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.AccessModeEnabledDesc)));
				this.lstTimeStampModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.TimeStampModeEnabledDesc)));
				this.lstEventModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.EventModeEnabledDesc)));
				this.lstPrinterEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.PrinterEnabledDesc)));
				this.lstTurnstileEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.TurnstileEnabledDesc)));
				this.lstLEDEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.LEDEnabledDesc)));
				this.lstEnable4ChannelScanningDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.Enable4ChannelScanningDesc)));
				this.lstOmniKeyOnlyDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.OmniKeyOnlyDesc)));
			},
			(error) => {
				this.LoadingScanStation = false;
			}
		);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRefresh
	//
	//-----------------------------------------------------------------------------------------------------	
	onRefresh() {
		this.loadTableData();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onExport
	//
	//-----------------------------------------------------------------------------------------------------
	onExport() {
		this.errorMessage = "";

		//
		// Get filtered list of values to export
		//
		var lstData: any = [];

		if (this.mydt.filteredValue != null) {
			lstData = this.mydt.filteredValue;
		} else {
			lstData = this.mydt._value;
		}

		//
		// Create CSV
		//
		var data: string = "";

		//
		// Create csv based on Table's data
		//
		data += "ScanStation,";
		data += "Facility,";
		data += "School,";
		data += "Active/Decommissioned,";
		data += "Decommission Date,";
		data += "Last Sync Date" + "\r\n";

		//
		// Go through each entry in the table and add the data
		//
		for (var i = 0; i < lstData.length; i++) {
			var next = lstData[i];

			data += '"' + next.ScanStation + '",';
			data += '"' + next.FacilityName + '",';
			data += '"' + next.SchoolFullName + '",';
			data += '"' + next.IsDecommissionedDesc	+ '",';
			data += '"' + next.DecommissionedDTDesc + '",';
			data += '"' + next.SyncDownStartDTDesc + '",';
			data += '"' + next.StationRebuildDateDesc + "\r\n";
		}

		//
		// Download CSV
		//
		var blob = new Blob([data], { type: "text" });
		var url = window.URL.createObjectURL(blob);

		var a = document.createElement("a");
		a.href = url;

		a.download = "ScanStationTracking_" + moment(new Date()).format("MM_DD_YYYY") + ".csv";
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onResetColOptions
	//
	//-----------------------------------------------------------------------------------------------------	
	onResetColOptions() {
		this.SelectedColumns = [];

		for (var a = 0; a < this.lstCategory.length; a++) {
			var cat = this.lstCategory[a];

			for (var b = 0; b < cat.lstColumns.length; b++) {
				var col = cat.lstColumns[b];

				if (col.Selected == true) {
					this.SelectedColumns = [...this.SelectedColumns, col];
				}
			}
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSchoolChange
	//
	//-----------------------------------------------------------------------------------------------------	
	onSchoolChange(val) {
		this.SelectedSchool = val;

		this.loadFacility();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onFacilityChange
	//
	//-----------------------------------------------------------------------------------------------------	
	onFacilityChange(val) {
		this.SelectedFacility = val;

		if (this.IsLoading() == false) {
			this.loadTableData();
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onActiveOptionChange
	//
	//-----------------------------------------------------------------------------------------------------		
	onActiveOptionChange(val) {
		this.ActiveOption = val;

		if (this.IsLoading() == false) {
			this.loadTableData();
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onUpdateDecommissioned
	//
	//-----------------------------------------------------------------------------------------------------		
	onUpdateDecommissioned(ss, val) {
		this.errorMessage = "";

		var Msg: string = "";

		if (val == true) {
			Msg = "Are you sure you want to decommission " + ss.ScanStation + "?";
		} else {
			Msg = "Are you sure you want to Re-commission " + ss.ScanStation + "?";
		}

		this.confirmationService.confirm({
			key: "sstmain",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: Msg,
			header: "Confirm " + (val == true ? "Decommission" : "Re-Commission"),
			icon: "fa",
			accept: () => {
				this.onFinishUpdateDecommissioned(ss, val);
			},
			reject: () => {
				ss.IsDecommissioned = !val;
				if (ss.IsDecommissioned == true) {
					ss.IsDecommissionedDesc = "Yes";
				} else {
					ss.IsDecommissionedDesc = "No";
				}
			},
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onFinishUpdateDecommissioned
	//
	//-----------------------------------------------------------------------------------------------------		
	onFinishUpdateDecommissioned(ss, val) {
		this.Processing = true;

		let parms: wsScanStationTrackingUpdateParmInfo = {
			c_PersonID: this.user.personID,
			ChangedItems: [],
		};

		let r: wsScanStationTrackingUpdateItemInfo = {
			ScanStationID: ss.ScanStationID,
			isDecommissioned: val,
		};

		console.log("r: ", r);

		parms.ChangedItems.push(r);

		console.log("parm: ", parms);


		var result = this.dataService.ScanStationTrackingUpdate(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == false) {
					this.errorMessage = response.ErrorMessage;
				} else {
					this.onRefresh();
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}	

	//-----------------------------------------------------------------------------------------------------
	//
	//	IsLoading
	//
	//-----------------------------------------------------------------------------------------------------	
	IsLoading() {
		return this.LoadingFacility == true || this.LoadingCategory == true || this.LoadingScanStation == true || this.Processing == true;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IsSelected
	//
	//-----------------------------------------------------------------------------------------------------		
	IsSelected(colName: string) {
		for (var z = 0; z < this.SelectedColumns.length; z++) {
			var next = this.SelectedColumns[z];

			if (next.DataField == colName) {
				return true;
			}
		}

		return false;
	}

}

export interface CategoryInfo {
	Category: string;
	lstColumns: ColumnInfo[];
}

export interface ColumnInfo {
	ColumnName: string;
	Selected: boolean;
	ReadOnly: boolean;
	DataField: string;
}
